import request from '@/utils/request01'
// 邮箱注册
export function registered(data) {
  return request({
    url: 'user/SendRegisterEmailToNotInChatroom/',
    method: 'post',
    data
  })
}
